<template>
  <transition name="network-notification-fade" tag="div">
    <div v-show="showNotification" class="ui-notification-container">
      <div class="ui-notification">
        <fluent-icon icon="wifi-off" />
        <p class="ui-notification-text">
          {{
            useInstallationName(
              $t('NETWORK.NOTIFICATION.TEXT'),
              globalConfig.installationName
            )
          }}
        </p>
        <woot-button
          variant="smooth"
          size="small"
          color-scheme="warning"
          icon="arrow-clockwise"
          @click="refreshPage"
        />
        <woot-button
          variant="smooth"
          size="small"
          color-scheme="warning"
          icon="dismiss-circle"
          @click="closeNotification"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { mapGetters } from 'vuex';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  mixins: [globalConfigMixin],

  data() {
    return {
      online: navigator.onLine,
      websocket_connected: true,
    };
  },

  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    showNotification() {
      return !this.online || !this.websocket_connected;
    },
  },

  mounted() {
    window.addEventListener('offline', this.updateOnlineStatus);
    window.addEventListener('online', this.updateOnlineStatus);
    window.bus.$on(BUS_EVENTS.WEBSOCKET_DISCONNECT, this.updateOnlineStatus);
    window.bus.$on(BUS_EVENTS.WEBSOCKET_RECONNECT, this.updateOnlineStatus);
  },

  beforeDestroy() {
    window.removeEventListener('offline', this.updateOnlineStatus);
    window.removeEventListener('online', this.updateOnlineStatus);
    window.bus.$off(BUS_EVENTS.WEBSOCKET_DISCONNECT, this.updateOnlineStatus);
    window.bus.$off(BUS_EVENTS.WEBSOCKET_RECONNECT, this.updateOnlineStatus);
  },

  methods: {
    refreshPage() {
      window.location.reload();
    },

    closeNotification() {
      this.online = this.websocket_connected = null;
    },

    updateOnlineStatus(event) {
      if (!event || !event.type) return;
      if (event.type === 'offline' || event.type === 'online') {
        this.online = event.type === 'online';
      } else if (
        event.type === 'websocket_disconnected' ||
        event.type === 'websocket_reconnected'
      ) {
        this.websocket_connected = event.type === 'websocket_reconnected';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/mixins';

.ui-notification-container {
  max-width: 40rem;
  position: absolute;
  left: var(--space-small);
  top: var(--space-small);
  z-index: var(--z-index-very-high);
}

.ui-notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  background-color: var(--y-100);
  border-radius: var(--border-radius-medium);
  box-shadow: var(--shadow-large);

  min-width: 24rem;
  padding: var(--space-small);
}

.ui-notification-text {
  margin: 0 var(--space-small);
}
</style>
